package xim.poc.game.configuration.v0.tactics

import xim.poc.audio.SystemSound
import xim.poc.game.ActorType
import xim.poc.game.QueryMenuOption
import xim.poc.game.QueryMenuResponse
import xim.poc.game.UiStateHelper
import xim.poc.game.configuration.v0.TacticsUnit

class TacticsSummonSelectUi(val ui: TacticsUi) {

    fun push() {
        UiStateHelper.openQueryMode(
            prompt = "Summon which unit? (${ui.match.getSummonedUnitCount()}/4)",
            options = getOptions(),
            enableCursorMovementKeys = true,
            drawFn = { ui.draw(); drawUnitDescription(it) }) {
            handleChoice(it)
        }
    }

    private fun getOptions(): List<QueryMenuOption> {
        return getSummonableUnits()
            .filter { canSummon(it) }
            .map { QueryMenuOption(it.name, it.id) } + QueryMenuOption("Cancel", -1)
    }

    private fun handleChoice(queryMenuOption: QueryMenuOption?): QueryMenuResponse {
        if (queryMenuOption == null || queryMenuOption.value < 0) { return QueryMenuResponse.pop }

        val unit = getSummonableUnits().firstOrNull { it.id == queryMenuOption.value }
            ?: return QueryMenuResponse.pop

        if (ui.match.summonPlayerUnit(unit) == null) {
            return QueryMenuResponse.noop(sound = SystemSound.Invalid)
        }

        return QueryMenuResponse.pop(SystemSound.MenuSelect)
    }

    private fun getSummonableUnits(): List<TacticsUnit> {
        return TacticsState.getPlayerUnits()
    }

    private fun canSummon(unit: TacticsUnit): Boolean {
        return ui.match.canSummonUnit(unit) == null
    }

    private fun drawUnitDescription(queryMenuOption: QueryMenuOption) {
        val unit = getSummonableUnits().firstOrNull { it.id == queryMenuOption.value } ?: return
        TacticsUnitDescription.drawUnitDescription(unit, ActorType.AllyNpc)
    }

}